import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SupplierDropOption } from 'routes/set-supplier/type';
import { RootState } from '../../app/store';

import { login } from './api';

import { AuthState, UpdateUserResponse, LoginBody } from './types';

const initialState: AuthState = {
    user: JSON.parse(localStorage.getItem('user') ?? 'null'),
    token: localStorage.getItem('auth_token'),
    status: 'idle',
    supplierId: parseInt(localStorage.getItem('supplier_id') ?? '0') || undefined,
    businessType: parseInt(localStorage.getItem('business-type') ?? '0') || undefined,
    HaveCustomizeReports: localStorage.getItem('have-customize-reports') === 'true'
};

export const loginApi = createAsyncThunk(
    'auth/login',
    async (params: LoginBody) => {
        const response = await login(params);

        return response.data;
    },
);

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        updateUserFun: (state, action: PayloadAction<UpdateUserResponse>) => {
            state.token = action.payload.token;

            if(state.user){
                state.user.fullName = action.payload.user.fullName;
                state.user.mobileNumber = action.payload.user.mobileNumber;
                state.user.supplierCompany = action.payload.user.supplierCompany;
                state.user.supplierTitle = action.payload.user.supplierTitle;
                state.user.picture = action.payload.user.picture;
            }           

            localStorage.setItem('user', JSON.stringify(state.user));

            localStorage.setItem('access_token', action.payload.token);
        },
        logOutFun: (state) => {
            state.token = null;
            state.user = undefined;
            state.supplierId = undefined;
            state.businessType = undefined;
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            localStorage.removeItem('supplier_id');
            localStorage.removeItem('business-type');
            localStorage.removeItem('have-customize-reports');
        },
        setSupplierInfo: (state, action: PayloadAction<SupplierDropOption>) => {
            state.supplierId = action.payload?.value;
            state.businessType = action.payload?.businessType;

            localStorage.setItem('supplier_id', action.payload?.value?.toString() ?? '0');
            localStorage.setItem('business-type', action.payload?.businessType?.toString() ?? '10');
        },
        setSupplierHaveCustomizeReports: (state, action: PayloadAction<boolean>) => {
            state.HaveCustomizeReports = action.payload;

            localStorage.setItem('have-customize-reports', action.payload ? 'true' : 'false');
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginApi.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(loginApi.fulfilled, (state, action) => {
                state.status = 'idle';
                state.user = action.payload.user;
                state.token = action.payload.token;

                localStorage.setItem(
                    'user',
                    JSON.stringify(action.payload.user),
                );

                localStorage.setItem('access_token', action.payload.token);
            });
    },
});

export const { updateUserFun, logOutFun, setSupplierInfo, setSupplierHaveCustomizeReports } = authSlice.actions;

export const selectUser = (state: RootState) => state.auth.user;
export const selectStatus = (state: RootState) => state.auth.status;
export const selectSupplierId = (state: RootState) => state.auth.supplierId;
export const selectBusinessType = (state: RootState) => state.auth.businessType;
export const selectSupplierHaveCustomizeReports = (state: RootState) => state.auth.HaveCustomizeReports;

export default authSlice.reducer;
